@if (buttons().length) {
  <div role="group" class="group" [class.homepage]="type() === 'homepage'" [attr.aria-label]="config().ariaLabel">
    @for (button of buttons(); track $index) {
      <app-social-sharing-button [config]="button" [type]="type()" />
    }
  </div>
}
